import React from 'react';
import { RefreshCw, CheckCircle, AlertCircle, Clock } from 'lucide-react';
export function SyncPage() {
  // Mock calendar days
  const days = Array.from({
    length: 30
  }, (_, i) => {
    const status = Math.random() > 0.8 ? 'error' : Math.random() > 0.6 ? 'pending' : 'synced';
    return {
      day: i + 1,
      status
    };
  });
  return <div className="p-4 pb-20 space-y-6" data-id="element-272">
      <h1 className="text-2xl font-bold text-white" data-id="element-273">Data Sync</h1>

      {/* Status Card */}
      <div className="bg-slate-800 rounded-xl p-6 border border-slate-700 text-center" data-id="element-274">
        <div className="w-16 h-16 bg-blue-500/10 rounded-full flex items-center justify-center mx-auto mb-4 text-blue-500" data-id="element-275">
          <RefreshCw size={32} data-id="element-276" />
        </div>
        <h2 className="text-lg font-bold text-white mb-1" data-id="element-277">Sync Status</h2>
        <p className="text-slate-400 text-sm mb-6" data-id="element-278">
          Last synced 15 minutes ago
        </p>

        <div className="grid grid-cols-3 gap-4 border-t border-slate-700 pt-4" data-id="element-279">
          <div data-id="element-280">
            <div className="text-2xl font-bold text-white" data-id="element-281">142</div>
            <div className="text-xs text-slate-500 uppercase" data-id="element-282">Total</div>
          </div>
          <div data-id="element-283">
            <div className="text-2xl font-bold text-yellow-500" data-id="element-284">5</div>
            <div className="text-xs text-slate-500 uppercase" data-id="element-285">Pending</div>
          </div>
          <div data-id="element-286">
            <div className="text-2xl font-bold text-red-500" data-id="element-287">2</div>
            <div className="text-xs text-slate-500 uppercase" data-id="element-288">Errors</div>
          </div>
        </div>
      </div>

      {/* Calendar View */}
      <div data-id="element-289">
        <h3 className="text-white font-medium mb-4" data-id="element-290">November 2023</h3>
        <div className="grid grid-cols-7 gap-2" data-id="element-291">
          {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map(d => <div key={d} className="text-center text-xs text-slate-500 font-medium py-2" data-id="element-292">
              {d}
            </div>)}
          {days.map(d => {
          let bgClass = 'bg-slate-800 text-slate-400';
          if (d.status === 'synced') bgClass = 'bg-green-500/10 text-green-400 border border-green-500/20';
          if (d.status === 'pending') bgClass = 'bg-yellow-500/10 text-yellow-400 border border-yellow-500/20';
          if (d.status === 'error') bgClass = 'bg-red-500/10 text-red-400 border border-red-500/20';
          return <div key={d.day} className={`aspect-square rounded-lg flex items-center justify-center text-sm font-medium ${bgClass}`} data-id="element-293">
                {d.day}
              </div>;
        })}
        </div>
      </div>

      {/* Legend */}
      <div className="flex justify-between px-2" data-id="element-294">
        <div className="flex items-center space-x-2" data-id="element-295">
          <div className="w-3 h-3 rounded-full bg-green-500" data-id="element-296" />
          <span className="text-xs text-slate-400" data-id="element-297">Synced</span>
        </div>
        <div className="flex items-center space-x-2" data-id="element-298">
          <div className="w-3 h-3 rounded-full bg-yellow-500" data-id="element-299" />
          <span className="text-xs text-slate-400" data-id="element-300">Pending</span>
        </div>
        <div className="flex items-center space-x-2" data-id="element-301">
          <div className="w-3 h-3 rounded-full bg-red-500" data-id="element-302" />
          <span className="text-xs text-slate-400" data-id="element-303">Error</span>
        </div>
      </div>

      <button className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-4 rounded-xl transition-colors flex items-center justify-center space-x-2" data-id="element-304">
        <RefreshCw size={20} data-id="element-305" />
        <span data-id="element-306">Sync All Data Now</span>
      </button>
    </div>;
}